import { del } from "../methods";
function deleteUserCompanyPeers_default({ peerCollectionId }, headers = {}) {
  const config = {
    url: `backend/company-peers/user/peers/${peerCollectionId}`,
    headers,
    payload: {}
  };
  return del(config);
}
export {
  deleteUserCompanyPeers_default as default
};
